import { RefType } from '@commerce-payment-webcomponents/sdk';
import { PaymentSummary } from '@commerce-payment-webcomponents/ui';
import { paymentMethodProviderIdEnum, SOPPaymentSummaryTypes } from './types/SOPPaymentSummaryTypes';

const SOPPaymentSummary = ({ paymentMethodProvider, profileId, paymentId, cardId }: SOPPaymentSummaryTypes) => {
  const shouldEnableDirectDebit = paymentMethodProvider === paymentMethodProviderIdEnum.ODD;

  return (
    <>
      {shouldEnableDirectDebit ? (
        <div data-testid="direct-debit-payment-summary">
          <PaymentSummary enableDirectDebit={shouldEnableDirectDebit} />
        </div>
      ) : (
        <div data-testid="credit-debit-payment-summary">
          <PaymentSummary
            key={profileId}
            paymentId={paymentId}
            hidePaymentSummaryAmount={true}
            refType={RefType.Subscription}
            cardId={cardId}
          />
        </div>
      )}
    </>
  );
};

export default SOPPaymentSummary;
